import './About.sass';

function About() {
  const fullBand = require('../assets/full_band.jpg');

  const members = [
    {
      name: 'George White',
      photo: require('../assets/george.jpg'),
      jobs: ['Bouzouki', 'Banjo', 'Mandolin', 'Guitar', 'Vocals'],
      bio: 'is from Pittsburgh, PA and has been playing music in one form or another for over two decades. His adventure in Celtic music started at 14 when he got his first mandolin and a Dubliners CD, and he hasn\'t stopped looking for new songs and instruments since.'
    }, {
      name: 'Conor Freeland',
      photo: require('../assets/conor.jpg'),
      jobs: ['Uilleann Pipes', 'Whistles', 'Vocals'],
      bio: 'grew up in northeast Ohio. He has loved Irish music since a very early age, when his parents would sing him Pogues songs before bed. His experimentations with the bagpipes began in 2007 with the Great Highland Pipes, followed later by the Scottish Smallpipes and Uilleann pipes, due to the need for a quieter instrument to play near other humans. By day he works as a software engineer, but only to sustain his crippling music habit.'
    }, {
      name: 'Andy Morrison',
      photo: require('../assets/andy.jpg'),
      jobs: ['Guitar', 'Mandolin', 'Banjo', 'Harmonica', 'Accordion', 'Vocals'],
      bio: 'was raised in Michigan and came to Pittsburgh in search of work, and stumbled into the Irish scene. Irish music became a passion later in life, taking hold in college and evolving from the humble beginnings of a mandolin and a handful of tunes from Flogging Molly and the Pogues. Andy has made his place filling in the sound on whatever instrument helps complete the song.'
    }, {
      name: 'Dylan Rooke',
      photo: require('../assets/dylan.jpg'),
      jobs: ['Upright Bass', 'Guitar', 'Vocals'],
      bio: 'is an Irish citizen of foreign birth (Mckeesport, PA) by way of an immigrant father of the international Irish diaspora. He came into an appreciation for celtic folk music as a teenager via the punk music scene\'s intersections with international music and has found a deep love for the traditional and folk tunes of his heritage.'
    }, {
      name: 'Bill Buchko',
      photo: require('../assets/bill.jpg'),
      jobs: ['Bodhrán', 'Cajon'],
      bio: 'grew up in Pittsburgh and had his first taste of Irish culture while visiting Dublin in college. Having been a drummer for years, a friend suggested that he bring a drum to a St. Paddy\'s Day party to join in with the band. That started him down the path of playing Irish music for over a decade. While being an engineer is his day job, playing along to some Irish tunes with a pint in hand is his passion.'
    }
  ]

  return (
    <div className="AboutPane">
      <div className="Overview">
        <p className="AboutText">
          Bealtaine is a folk band based in Pittsburgh, striving to keep traditions alive while borrowing influence from the modern world. With roots in Irish and Scottish folk, songs from the Canadian Maritimes, trad tunes, and working-class anthems, Bealtaine looks to make their own mark in the folk music world.
        </p>
        <img src={fullBand} alt="The members of the band Bealtaine." />
      </div>
      {members.map((member, index) => (
        <div key={member.name} className="Bio" style={{animationDelay: ((index * 0.1) + 0.1) + 's'}}>
          <div  className="PhotoFrame" style={index % 2 === 0 ?
            {float: 'left', marginRight: '10px'} : {float: 'right', marginLeft: '10px'}}>
            <img src={member.photo} alt={member.name} />
            <p className="Jobs">{member.jobs.join(', ')}</p>
          </div>
          <p><span className="Celtic">{member.name} </span>{member.bio}</p>
        </div>
      ))}
    </div>
  )
}

export default About;
